<template>
  <div class="m-popover-notification-list">
    <transition-group
      name="m-popover-notification-list"
      tag="div"
      class="m-popover-notification-list__transition"
      role="status"
      aria-live="polite"
      aria-relevant="additions removals"
    >
      <slot />
    </transition-group>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'MPopoverNotificationList',
})
</script>

<style lang="scss" scoped>
@use '../../../sass/framework/mixins/container';

.m-popover-notification-list {
  // To clear the main navbar
  --popover-list-top-offset: calc(var(--header-height) + var(--spacing-24));
  @include container.container--gutter;
  bottom: 0;
  max-width: 408px;
  // New items appear at the top (below the navbar)
  // But if we get too many, will start moving up off
  // the screen to allow new ones to keep coming in at the bottom.
  // Design limit is 6, so should be a super edge case
  min-height: 100dvh;
  padding-top: var(--popover-list-top-offset);
  pointer-events: none;
  position: fixed;
  right: 0;
  width: 100%;
  // Go in front of everything except modals
  z-index: calc(var(--z-index-modal-overlay) - 1);

  &__transition {
    position: relative;
    // We can't use flex or grid here
    // as it messes with the exit animation positioning
    // So we have to do this naughty hack
    :deep(> *) {
      margin-bottom: var(--spacing-16);
      pointer-events: auto;
    }
  }
}

:deep(.m-popover-notification-list-enter-active),
:deep(.m-popover-notification-list-leave-active),
:deep(.m-popover-notification-list-move) {
  transition:
    opacity var(--animation),
    transform var(--animation);
}

:deep(.m-popover-notification-list-enter) {
  opacity: 0;
  transform: translateX(1em);
}

:deep(.m-popover-notification-list-leave-to) {
  opacity: 0;
}

:deep(.m-popover-notification-list-leave-active) {
  position: absolute;
}
</style>
